// removed by extract-text-webpack-plugin
module.exports = {"box":"c-MessageBox__box","fadein":"c-MessageBox__fadein","withBorder":"c-MessageBox__withBorder","error":"c-MessageBox__error","warning":"c-MessageBox__warning","info":"c-MessageBox__info","success":"c-MessageBox__success","spacingTop":"c-MessageBox__spacingTop","spacingBottom":"c-MessageBox__spacingBottom","center":"c-MessageBox__center"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/MessageBox/MessageBox.scss
// module id = 843
// module chunks = 0